import { authConfig } from "../apiConfig";


export const get_leaveRequest_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getEmployeeLeaves`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const update_leaveRequest = async (data) => {
    try {
        const response = await authConfig.post(`ApproveLeave`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response?.data;
    } catch (error) {
        throw error;
    }
};
export const get_leaveRequest_without_pagination = async () => {
    try {
        const response = await authConfig.post(`getEmployeeLeaves`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// FOR CPMPENSATION LEAVE
export const get_compensationLeave_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getCompensationLeaveSummary`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
}